"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _immutable = require("immutable");

var _BookingFormField = _interopRequireDefault(require("./BookingFormField"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _propertyTranslator = require("property-translator/propertyTranslator");

var displayName = 'CustomFormInputs';
var propTypes = {
  formFields: _propTypes.default.instanceOf(_immutable.List).isRequired,
  customFormFields: _propTypes.default.instanceOf(_immutable.Map).isRequired,
  onCustomFormFieldChange: _propTypes.default.func.isRequired,
  formStateValidation: _propTypes.default.instanceOf(_immutable.Map).isRequired
};

var CustomFormInputs = function CustomFormInputs(_ref) {
  var formFields = _ref.formFields,
      customFormFields = _ref.customFormFields,
      onCustomFormFieldChange = _ref.onCustomFormFieldChange,
      formStateValidation = _ref.formStateValidation;
  return _react.default.createElement("div", {
    style: {
      wordWrap: 'break-word'
    }
  }, formFields.map(function (field) {
    return _react.default.createElement(_BookingFormField.default, {
      fieldValue: customFormFields.get(field.name),
      fieldName: field.name,
      validation: formStateValidation.get(field.name),
      setFormValue: onCustomFormFieldChange,
      type: field.type,
      fieldType: field.fieldType,
      isRequired: field.isRequired,
      fieldLabel: (0, _propertyTranslator.propertyLabelTranslator)(field.label),
      fieldOptions: field.options,
      fieldIsCustom: field.isCustom,
      key: "" + field.name,
      numberDisplayHint: field.numberDisplayHint
    });
  }));
};

CustomFormInputs.displayName = displayName;
CustomFormInputs.propTypes = propTypes;
var _default = CustomFormInputs;
exports.default = _default;
module.exports = exports.default;